import * as KioskActions from '../Constants/index';

export const setMachineStructureData = (payload) => {
    return {
        type:KioskActions.SET_MACHINE_STRUCTURE_DATA,
        data:payload
    }
}

export const setKitchenEvents = (payload) => {
    return {
        type:KioskActions.SET_KITCHEN_EVENTS,
        data:payload
    }
}

export const setActiveModuleType = (payload) => {
    return {
        type:KioskActions.SET_ACTIVE_MODULE_TYPE,
        data:payload
    }
}

export const setActiveModuleTypeData = (payload) => {
    return {
        type:KioskActions.SET_ACTIVE_MODULE_TYPE_DATA,
        data:payload
    }
}

export const setActiveModule = (payload) => {
    return {
        type:KioskActions.SET_ACTIVE_MODULE,
        data:payload
    }
}

export const setActiveModuleData = (payload) => {
    return {
        type:KioskActions.SET_ACTIVE_MODULE_DATA,
        data:payload
    }
}

export const setActiveSystem = (payload) => {
    return {
        type:KioskActions.SET_ACTIVE_SYSTEM,
        data:payload
    }
}

export const getKitchenStates = (payload) => {
    return{
        type:"GET_KITCHEN_STATES",
        data:payload
    }
}

export const setActiveTask = (payload) => {
    return{
        type:"ACTIVE_TASK_SET",
        data:payload
    }
}

export const setRestaurantData = (payload) => {
    return{
        type:KioskActions.SET_RESTAURANT_DATA,
        data:payload
    }
}